import './ga4';
import './swiper';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

window.addEventListener('load', function() {
    //
    // scroll tout en haut de la page lors de l'ouverture du menu
    //
    const open = document.querySelector('.hamburger.hamburger-open');

    if (open) {
        open.addEventListener('click', () => {
            window.scrollTo({
                behavior: 'smooth',
                top: 0,
            });
        });
    }

    //
    // fermeture du menu lors du redimensionnement de la fenêtre
    //
    const close = document.querySelector('.hamburger.hamburger-close');

    window.addEventListener('resize', () => {
        if (close) {
            close.click();
        }
    });
});